import React from "react";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CreateInstitutionDialog = ({
  open,
  onClose,
  onSave,
  formData,
  onChange,
  regiones,
  provincias,
  distritos,
  loading,
  canSave,
}) => {
  const isLoadingOptions = loading.regiones || loading.provincias || loading.distritos;
  const isSaving = loading.crearInstitucion;

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={titleStyles}>
        Crear nueva institución
        <IconButton onClick={onClose} sx={{ color: "#fff" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ px: 3, py: 3 }}>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Código modular"
              name="id"
              value={formData.id}
              onChange={onChange}
              inputProps={{ maxLength: 7 }}
              helperText="7 dígitos"
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Código institución"
              name="codigo_institucion"
              value={formData.codigo_institucion}
              onChange={onChange}
              helperText="Opcional"
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Nivel / modalidad"
              name="nivel_modalidad"
              value={formData.nivel_modalidad}
              onChange={onChange}
              helperText="Ej. Primaria, Secundaria"
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Nombre de la institución"
              name="nombre"
              value={formData.nombre}
              onChange={onChange}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Tipo de gestión"
              name="tipo_gestion"
              value={formData.tipo_gestion}
              onChange={onChange}
              helperText="Opcional"
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <TextField
              fullWidth
              label="Dirección"
              name="direccion"
              value={formData.direccion}
              onChange={onChange}
              helperText="Opcional"
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              select
              fullWidth
              label="Región"
              name="region_id"
              value={formData.region_id}
              onChange={onChange}
              disabled={loading.regiones}
            >
              {regiones.map((region) => (
                <MenuItem key={region.id} value={region.id}>
                  {region.nombre}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              select
              fullWidth
              label="Provincia"
              name="provincia_id"
              value={formData.provincia_id}
              onChange={onChange}
              disabled={!formData.region_id || loading.provincias}
            >
              {provincias.map((provincia) => (
                <MenuItem key={provincia.id} value={provincia.id}>
                  {provincia.nombre}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              select
              fullWidth
              label="Distrito"
              name="distrito_id"
              value={formData.distrito_id}
              onChange={onChange}
              disabled={!formData.provincia_id || loading.distritos}
            >
              {distritos.map((distrito) => (
                <MenuItem key={distrito.id} value={distrito.id}>
                  {distrito.nombre}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5, pt: 1, gap: 1 }}>
        <Button onClick={onClose} variant="outlined" sx={buttonStyles}>
          Cancelar
        </Button>
        <Button
          onClick={onSave}
          variant="contained"
          disabled={!canSave || isSaving || isLoadingOptions}
          sx={saveButtonStyles}
        >
          {isSaving ? <CircularProgress size={24} color="inherit" /> : "Registrar institución"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const titleStyles = {
  backgroundColor: "#36538f",
  color: "#fff",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  fontFamily: "Montserrat-Bold",
  fontSize: "1rem",
  px: 3,
  py: 2,
};

const buttonStyles = {
  textTransform: "none",
  fontFamily: "Montserrat-Medium",
  borderRadius: "8px",
  px: 2.5,
  boxShadow: "none",
};

const saveButtonStyles = {
  ...buttonStyles,
  backgroundColor: "#36538f",
  "&:hover": { backgroundColor: "#294277" },
};

export default CreateInstitutionDialog;
